import React, { Component } from 'react';
import DropdownItemSelectionManager from '../context/DropdownItemSelectionManager';
// HOC that typically wraps @atlaskit/item/ItemGroup
const withDropdownItemSelectionManager = (WrappedComponent, selectionBehavior) => class WithDropdownItemSelectionManager extends Component {
    render() {
        const { children, id, ...otherProps } = this.props;
        return (React.createElement(WrappedComponent, Object.assign({}, otherProps),
            React.createElement(DropdownItemSelectionManager, { groupId: id, behavior: selectionBehavior }, children)));
    }
};
export default withDropdownItemSelectionManager;
//# sourceMappingURL=withItemSelectionManager.js.map